var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.5V4.5H22V6.5H2ZM2 13.5V11.5H14V13.5H2ZM2 18.5V20.5H22V18.5H2Z",
    fill: "#B5B5BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.5L22 12.5L17 8.5L17 16.5Z",
    fill: "#B5B5BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuOpenIcon);
export default __webpack_public_path__ + "static/media/menu-open-icon.f6f03ba0a062bf238f600d7fb861a76d.svg";
export { ForwardRef as ReactComponent };